export const socialImages = [
  "https://i.imgur.com/KAGynOO.png",
  "https://i.imgur.com/i3D2bTH.png",
  "https://i.imgur.com/rbM1uIW.png",
  "https://i.imgur.com/HBl2emK.png",
  "https://i.imgur.com/34tkig2.png",
  "https://i.imgur.com/gIfvuAc.png",
  "https://i.imgur.com/DRi3dbs.png",
  "https://i.imgur.com/nrXBF6Z.png",
  "https://i.imgur.com/QpgoihA.png",
  "https://i.imgur.com/ShhTGRH.png",
  "https://i.imgur.com/3gtk4Rt.png",
  "https://i.imgur.com/lCuYPxj.png",
  "https://i.imgur.com/WvKejaD.png",
  "https://i.imgur.com/TdX1J6r.png",
  "https://i.imgur.com/fLUYUpr.png",
  "https://i.imgur.com/QQbWnQm.png",
  "https://i.imgur.com/3eRTfIF.png",
  "https://i.imgur.com/a4UECA2.png",
  "https://i.imgur.com/Qe3aCI0.jpg",
  "https://i.imgur.com/6Q4q9rm.png",
  "https://i.imgur.com/8EjEVnl.png",
  "https://i.imgur.com/h56WyOC.jpg",
  "https://i.imgur.com/UrX03uM.png",
  "https://i.imgur.com/LcLnzed.png",
  "https://i.imgur.com/U80MjQT.png",
  "https://i.imgur.com/lpzsrH9.png",
  "https://i.imgur.com/yq3eyhH.png",
  "https://i.imgur.com/9uFV0r4.png",
  "https://i.imgur.com/tzbr1PY.png",
  "https://i.imgur.com/Y72Zovr.png",
  "https://i.imgur.com/3E5QLrL.png",
  "https://i.imgur.com/ixm6W42.png",
  "https://i.imgur.com/ckwDCrr.png",
  "https://i.imgur.com/VHj3nlp.png",
  "https://i.imgur.com/lEvsC3x.png",
  "https://i.imgur.com/lYb3FXh.png",
  "https://i.imgur.com/Xagn31c.png",
  "https://i.imgur.com/tk0Y9Om.png",
  "https://i.imgur.com/mE9d0Ek.png",
  "https://i.imgur.com/nEcfNic.png",
  "https://i.imgur.com/eFKAqbB.png",
  "https://i.imgur.com/NI6YUEW.png",
  "https://i.imgur.com/o4wZq1I.png",
  "https://i.imgur.com/lFvaJQV.png",
  "https://i.imgur.com/64cZA3y.png",
  "https://i.imgur.com/j6JCKmX.png",
  "https://i.imgur.com/Gpxf5sE.png",
  "https://i.imgur.com/dT0ZUaf.png",
  "https://i.imgur.com/UhQR6RP.png",
  "https://i.imgur.com/WidsFYA.png",
];
export const brandingImages = [
  "https://i.imgur.com/y776Qs8.png",
  "https://i.imgur.com/akk284e.png",
  "https://i.imgur.com/JQkf1ft.png",
  "https://i.imgur.com/9wCVJZk.png",
  "https://i.imgur.com/xTNXLwi.png",
  "https://i.imgur.com/dtEancq.png",
  "https://i.imgur.com/TqaxLhk.png",
  "https://i.imgur.com/o9CzLbL.png",
  "https://i.imgur.com/o2zcq2y.png",
  "https://i.imgur.com/RmB1HNJ.png",
  "https://i.imgur.com/NP85Z5K.png",
  "https://i.imgur.com/xr6cgAr.png",
  "https://i.imgur.com/anjDqWN.png",
  "https://i.imgur.com/Ntdvkxe.png",
  "https://i.imgur.com/xAB3XnB.png",
  "https://i.imgur.com/VrEV0W2.png",
  "https://i.imgur.com/rmpmduq.png",
  "https://i.imgur.com/zkEtgvQ.png",
  "https://i.imgur.com/k6fdTE3.png",
  "https://i.imgur.com/ALjmCJh.png",
  "https://i.imgur.com/B45yxkh.png",
  "https://i.imgur.com/23gFcLt.png",
  "https://i.imgur.com/PzK6TUk.png",
  "https://i.imgur.com/Nx21Dpf.png",
  "https://i.imgur.com/RkJkesy.png",
];
export const diagramacaoImages = [
  "https://i.imgur.com/V51GhOw.png",
  "https://i.imgur.com/VtWotAM.png",
  "https://i.imgur.com/ZQuQXLf.png",
  "https://i.imgur.com/CLtBQaC.png",
  "https://i.imgur.com/bA7hvBt.png",
  "https://i.imgur.com/phS9dBk.png",
  "https://i.imgur.com/wNx0isk.png",
  "https://i.imgur.com/AqNjAn6.png",
  "https://i.imgur.com/XwU0vYc.png",
  "https://i.imgur.com/z5t8tA0.png",
  "https://i.imgur.com/IXfZkUD.png",
  "https://i.imgur.com/1FEghCU.png",
];
export const slidesImages = [
  "https://i.imgur.com/WypmRZH.png",
  "https://i.imgur.com/BdVRRq4.png",
  "https://i.imgur.com/bWbqbbR.png",
];
